export const TOKEN_KEY = '&app-token';
export const ID_USUARIO = '&id-usuario';
export const NOME_USUARIO = '&nome-usuario';
export const USER_EMAIL = '&user-email';
export const CATALOG_NAME = '&catalog-name';
export const USUARIO_CONFIG = '&usuario-config';
export const KEY_ROUTES = '&app-routes';

export const login = token => { localStorage.setItem(TOKEN_KEY, token); }
export const logout = () => { localStorage.clear(); }

export const setIdUsuario = id => localStorage.setItem(ID_USUARIO, id);
export const getIdUsuario = () => localStorage.getItem(ID_USUARIO);

export const setNomeUsuario = nome => localStorage.setItem(NOME_USUARIO, nome);
export const getNomeUsuario = () => localStorage.getItem(NOME_USUARIO);

export const setEmailUsuario = email => localStorage.setItem(USER_EMAIL, email);
export const getEmailUsuario = () => localStorage.getItem(USER_EMAIL);

export const setCatalogName = catalogName => localStorage.setItem(CATALOG_NAME, catalogName);
export const getCatalogName = () => localStorage.getItem(CATALOG_NAME);

export const setUsuarioConfig = config => localStorage.setItem(USUARIO_CONFIG, JSON.stringify(config));
export const getUsuarioConfig = () => JSON.parse(localStorage.getItem(USUARIO_CONFIG));

export const setRotas = rotas => localStorage.setItem(KEY_ROUTES, rotas);
export const getRotas = () => localStorage.getItem(KEY_ROUTES);

export const getToken = () => localStorage.getItem(TOKEN_KEY);
 